import React from 'react';
import { styled } from '@linaria/react';
import { useTheme, ITheme } from 'src/theme';

const ContainerElement = styled.div<ContainerBlockProps>`
  display: block;
  text-align: left;
  background: ${props => props.background ? props.background : 'none'};
  box-shadow: ${props => props.boxShadow ? props.boxShadow : 'none'};
  padding: ${props => typeof props.padding === 'number' ? `${props.padding}px` : props.padding};
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
  box-sizing: border-box;
  border-top: ${props => props.borderTop};
  &.tooltip {
    border-radius: 4px;
  }
  @media screen and (min-width: 768px) {
    padding: ${props => typeof props.paddingTablet === 'number' ? `${props.paddingTablet}px` : props.paddingTablet};
    margin: ${props => props.marginTablet ? (typeof props.marginTablet === 'number' ? `${props.marginTablet}px` : props.marginTablet) : props.margin};
  }
`

export interface ContainerBlockProps {
  children?: React.ReactNode;
  theme?: ITheme;
  background?: string | undefined | null;
  boxShadow?: string | undefined | null;
  padding: string | number;
  paddingTablet: string | number;
  margin: string | number;
  marginTablet?: string | number;
  borderTop: string;
  className: string;
  border?: string;
}

function ContainerBlock({ children, className, ...props }: ContainerBlockProps) {
  const theme = useTheme();
  return <ContainerElement className={className} theme={theme} {...props}>
    {children}
  </ContainerElement>;
};

ContainerBlock.defaultProps = {
  padding: 0,
  paddingTablet: 0,
  margin: '0 0 30px',
  background: false,
  boxShadow: false, 
  borderTop: 'none',
  className: ''
}

export default ContainerBlock;
